import React, { useMemo } from 'react';
import useGetGameStoreStatsInfo from '@/pages/opinion/widgets/GameStorePlate/hooks/useGetGameStoreStatsInfo';
import useGetGameStoreTimelineInfo from '@/pages/opinion/widgets/GameStorePlate/hooks/useGetGameStoreTimelineInfo';
import { GameStoreMobileChart } from '@/pages/opinion/widgets/GameStorePlate/components/GameStoreMobileChart';
import { useIntl } from 'umi';
import { XboxGameStore } from '@/pages/opinion/widgets/GameStorePlate/components/XboxGameStore';
import { formatDateFunc } from '@/pages/opinion/utils/time';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { Col, Justify, Row } from 'tea-component';
import CardLoading from '@/pages/opinion/components/CardLoading';
import {
  FilterFixed,
  useFilterDataHook,
} from '@/pages/opinion/components/FilterCommon';
import useFeedsDetail from '../../hooks/useFeedsDetail';
import { ExportDefaultType } from '@op/components/FilterCommon/types';

// const channel = 'xbox';

export default function XboxStore({ gameInfo, scrollBody, channel = 'xbox' }: any) {
  const { formatMessage } = useIntl();

  const {
    loading: initLoading,
    filter,
    changeFilter,
    filterOptions: options,
  } = useFilterDataHook({
    gameInfo,
    hasHero: true,
    pageName: 'GameStore_Xbox',
  });

  const {
    loading: statsLoading,
    ratingInfo,
    ratings,
  } = useGetGameStoreStatsInfo({
    gameInfo,
    filter,
    type: channel,
    lifetimeTitle: 'Lifetime Reviews',
    selectedTitle: 'Added Reviews',
  });

  const {
    trendLoading: xboxLoading,
    nodata,
    mobileTrendsInfo: xboxTrendsInfo,
  } = useGetGameStoreTimelineInfo({ gameInfo, filter, type: channel });
  const formatTime = formatDateFunc(filter?.date_type);
  const { feedsBtnElement } = useFeedsDetail({ filter, channel });
  const filterOptions: (keyof ExportDefaultType)[] = useMemo(() => {
    if (channel !== 'xbox') return options;
    return [...options, 'xboxEdition'];
  }, [options, channel]);

  return (
    <>
      <FilterFixed
        filter={filterOptions}
        scrollBody={scrollBody}
        confirm={(value: any) => {
          changeFilter({
            ...value,
            ...gameInfo,
            channel: [channel],
            channel_type: 'comments',
          });
        }}
        defaultConfig={{ region: { showTips: false } }}
        beforeCacheDealwithData={() => false}
        operateShowOptions={['history', 'more']}
      ></FilterFixed>
      <Justify right={feedsBtnElement}></Justify>
      <CardLoading loading={initLoading}>
        <div>
          {ratings.map(({ ratingKey, time, title }) => {
            const isLifetime = ratingKey === 'lifetime';
            const realTime = isLifetime ? formatTime(time) : time;
            return (
              <CardCommon key={title + ratingKey}>
                <Row gap={30}>
                  <Col span={12}>
                    <XboxGameStore
                      className="dbo-scorebox"
                      ratingKey={ratingKey}
                      key={ratingKey}
                      filter={filter}
                      time={realTime}
                      loading={statsLoading}
                      title={title}
                      height={248}
                      ratingInfo={ratingInfo[ratingKey]}
                      channel={channel}
                    ></XboxGameStore>
                  </Col>

                  <Col span={12}>
                    <GameStoreMobileChart
                      data={xboxTrendsInfo?.[ratingKey] || {}}
                      filter={filter}
                      // height={224}
                      loadingHeight={227}
                      hideLifetime={!isLifetime}
                      hideSelected={isLifetime}
                      isMin
                      loading={xboxLoading}
                      channel={channel}
                      formatMessage={formatMessage}
                      lifetimeTitle={'Lifetime Rating'}
                      selectedTitle={'Added Rating'}
                    ></GameStoreMobileChart>
                  </Col>
                </Row>
              </CardCommon>
            );
          })}
        </div>
      </CardLoading>
    </>
  );
}
